import React, { Component } from 'react';
import Catalogo from './Catálogo Cursos Extracurriculares 2026-2027 AASGV4.csv'; // Importa el archivo CSV
import './lectura.css'; // Importa el archivo CSS
import styled from 'styled-components';
import imagen from './Imagenes/ICONO ADMISIÓN_EB_Género2_Sin_Básica.png';
import imagenCondicion from './Imagenes/Cenefa flores.png'
import imagen2 from './Imagenes/emblemafederalmujer2-removebg-preview.png'

const ImagenFija = styled.img`
    position: fixed; /* La imagen permanece fija en la ventana */
    top: 0px; /* Posición desde la parte superior de la ventana */
    left: 0; /* Posición desde la parte izquierda de la ventana */
    width: 100px; /* Ancho de la imagen */
    height: 1000px; /* Mantiene la proporción de la imagen */
    z-index: -1; /* Coloca la imagen detrás de otros elementos */
    @media only screen and (max-width: 767px) {
       top: 0px; /* Posición desde la parte superior de la ventana */
       left: 450px; /* Posición desde la parte izquierda de la ventana */
       height:100% ;
       width: 10%;
       
    }

`;






const ImagenTitulo = styled.img`
    width: 20%;
    
`;

const ImagenTitulo2 = styled.img`
    width: 50%;
    margin-bottom:-1%;
    margin-left:30%;
    margin-top:-10%;
    @media only screen and (max-width: 767px) {
      visibility:hidden;
       
    }
`;

const ContenedorTitulo = styled.div`
    display: flex;
    align-items: center; /* Centra verticalmente los elementos */
    justify-content: flex-start;
    margin-left: 46%; /* Espacio del 3.5% a la izquierda */
    margin-top: 20px; /* Puedes ajustar el valor según sea necesario */
    margin-bottom: 20px; /* Puedes ajustar el valor según sea necesario */
    @media (max-width: 768px) {
      margin-left: 0; /* Elimina el margen izquierdo en pantallas pequeñas */
      width: 100%; /* Ocupa todo el ancho del contenedor en pantallas pequeñas */
      
      & > img {
          width: 25%; /* Ajusta el ancho de la imagen al 30% del contenedor */
          margin-left: 31%; /* Agrega un margen a la izquierda de la imagen en pantallas pequeñas */
      }
  }
      
`;



class Lectura extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      filterText1: '', // Estado para filtrar la "Columna 1"
      filterText2: '', // Estado para filtrar la "Columna 2"
      filterText3: '', // Estado para filtrar por opción múltiple
    };
  }

  componentDidMount() {
    // Accede al contenido del archivo CSV importado
    fetch(Catalogo)
      .then((response) => response.text())
      .then((data) => {
        const lines = data.split('\n');
        const items = [];
        for (let i = 0; i < lines.length; i++) {
          if (lines[i]) {
            const rowData = lines[i].split('*,').map((item) => item.replace(/\*/g, '')); // Divide los datos por el carácter '*' y elimina '*'
            items.push(rowData); // Agrega el arreglo de datos a items
          }
        }
        this.setState({ data: items });
      })
      .catch((error) => {
        console.error("Error al cargar los Cursos Extracurriculares:", error);
      });
  }

  handleFilterTextChange1 = (event) => {
    // Actualiza el estado de filtro para la "Columna 1" con el texto ingresado por el usuario
    this.setState({ filterText1: event.target.value });
  }

  handleFilterTextChange2 = (event) => {
    // Actualiza el estado de filtro para la "Columna 2" con el texto ingresado por el usuario
    this.setState({ filterText2: event.target.value });
  }

  handleFilterTextChange3 = (event) => {
    // Actualiza el estado de filtro para opciones múltiples
    this.setState({ filterText3: event.target.value });
  }

  render() {
    const opcionesConTitulos = {
      'DORADO': 'DORADO',
      'GRIS': 'BLANCO',
      'OtroColor': 'OtroColor', // Puedes agregar más colores según sea necesario
    };
    const { data, filterText1, filterText2, filterText3 } = this.state;

    // Filtra los datos basados en los textos de filtro
    const filteredData = data.filter(item =>
      item[1].toLowerCase().includes(filterText1.toLowerCase()) &&
      item[3].toLowerCase().includes(filterText2.toLowerCase()) &&
      (filterText3 === '' || item[0].toLowerCase() === filterText3.toLowerCase())
    );

    // Obtén las opciones únicas para el filtro múltiple
    const uniqueOptions = [...new Set(data.map(item => item[0]))];

    return (
   
      <div>
          <ContenedorTitulo>
                <ImagenTitulo src={imagen} alt="Ejemplo" />
                  <ImagenTitulo2 src={imagen2} alt="Ejemplo" />
            </ContenedorTitulo>
        
        <div>
          <div className="filter-container">
            <div>
            <h3>Filtrar por nombre del curso extracurricular:</h3>
              <input
                type="text"
                placeholder=""
                value={filterText2}
                onChange={this.handleFilterTextChange2}
              />
            
            </div>
            <div>
            <h3>Filtrar por nombre de la institución:</h3>
              <input
                type="text"
                placeholder=""
                value={filterText1}
                onChange={this.handleFilterTextChange1}
              />
             
            </div>
           
          </div>
        </div>
        
        <ImagenFija src={imagenCondicion} alt="Imagen fija" />
    
        
        <div className="table-container">
          {filteredData.length > 0 ? (
            <table>
              <thead>
                <tr>
                  {/*<th>#</th>*/}
                 
                  <th>Institución que imparte el Curso Extracurricular</th>
                  <th>Tipo de Formación</th>
                  <th>Nombre del Curso Extracurricular</th>
                  <th>Duración(Horas)</th>
                 
                  
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item, index) => (
                  <tr key={index} data-color={item[0]}>
                   {/*} <td>{index + 1}</td>*/}
                    <td>{item[1]}</td>
                    <td>{item[2]}</td>
                    <td>{item[3]}</td>
                    <td>{item[4]}</td>
                   
                   
                    
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <h3 className='mensaje'>No se encontraron cursos extracurriculares...</h3>
          )}
        </div>
      </div>
    );
  }
}

export default Lectura;
